import { ReactNode } from 'react';

export type SecondaryButtonProps = {
  children?: ReactNode;
  disabled?: boolean;
  destructive?: boolean;
  onClick?: () => unknown;
  py?: number;
  px?: number;
};

const SecondaryButton = (props: SecondaryButtonProps) => {
  const { children, disabled, destructive, onClick, py = 19, px } = props;

  if (disabled) {
    return (
      <button
        className={`w-full rounded-[12px] border border-gray-50 font-roboto text-h4 font-bold text-gray-100`}
        disabled={disabled}
        style={{
          paddingTop: `${py}px`,
          paddingBottom: `${py}px`,
          paddingLeft: px ? `${px}px` : undefined,
          paddingRight: px ? `${px}px` : undefined,
        }}
      >
        {children}
      </button>
    );
  }

  if (destructive) {
    return (
      <button
        className={`w-full rounded-[12px] border border-gray-50 font-roboto text-h4 font-bold text-danger-red-200 sm:hover:border-danger-red-100`}
        onClick={onClick}
        style={{
          paddingTop: `${py}px`,
          paddingBottom: `${py}px`,
          paddingLeft: px ? `${px}px` : undefined,
          paddingRight: px ? `${px}px` : undefined,
        }}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      className={`w-full rounded-[12px] border border-gray-50 font-roboto text-h4 font-bold text-gray-600 sm:hover:border-green-200`}
      onClick={onClick}
      style={{
        paddingTop: `${py}px`,
        paddingBottom: `${py}px`,
        paddingLeft: px ? `${px}px` : undefined,
        paddingRight: px ? `${px}px` : undefined,
      }}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
